/** Tooltip wiring shared by the director and entity hover cards; each wrapper spreads it and adds its own extras. */
export const HOVER_CARD_TOOLTIP_PROPS = {
    direction: 'right',
    contentCss: { padding: 0 },
    fitContent: true,
    hideArrow: true,
    hideDelay: 150,
    showDelay: 100,
    usePortal: true,
    containTipClicks: true,
} as const;
